import { createApi, } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../../core/api/axiosBaseQuery';
import { BillingHistoryResponse, SubscriptionResponse } from '../types/types';
import { DashboardStatisticsResponse } from '../../dashboard/types/types';


export const ENROLLMENT_BASE_API_ENDPOINT = '/api/v1';
export const billingApi = createApi({
    reducerPath: 'billingApi',
    baseQuery: axiosBaseQuery({ baseUrl: ENROLLMENT_BASE_API_ENDPOINT }),
    tagTypes: ['BillingHistory', 'Subscription', 'DashboardStatistics', 'paymentMethods'],
    endpoints: (builder) => ({
        getGetTransactionHistory: builder.query<BillingHistoryResponse, { page?: number; limit?: number }>({
            query: ({ page, limit }: { page?: number; limit?: number }) => ({
                url: `/students/payment-history?page=${page || 1}&limit=${limit || 50}`,
                method: 'GET',
            }),
            transformResponse: (response: BillingHistoryResponse) => {
                return response;
            }
        }),
        getStudentSubscription: builder.query<SubscriptionResponse, void>({
            query: () => ({
                url: `/students/get-subscription`,
                method: 'GET',
            }),
            transformResponse: (response: any) => {
                return response;
            },
            providesTags: ['Subscription'],
        }),
        getDashboardStatistics: builder.query<DashboardStatisticsResponse, void>({
            query: () => ({
                url: '/students/statics',
                method: 'GET',
            }),
            transformResponse: (response: DashboardStatisticsResponse) => {
                return response;
            },
            
        }),
        cancelSubscription: builder.mutation<void, void>({
            query: () => ({
                url: '/students/cancel-subscription',
                method: 'PUT',
            }),
            transformResponse: (response: any) => {
                return response;
            },
            invalidatesTags: ['Subscription'],
        }),
        setupIntent: builder.query<{ data: string }, void>({
            query: () => ({
                url: '/students/setup-intent',
                method: 'POST',
            }),
            keepUnusedDataFor: 2,            
        }),
        getSavedPaymentMethods: builder.query<{ data: string }, void>({
            query: () => ({
                url: '/students/payment-methods',
                method: 'GET',
            }),
            providesTags: ['paymentMethods'],
        }),
        removePaymentMethod: builder.mutation<void, { paymentMethodId: string }>({
            query: ({ paymentMethodId }) => ({
                url: `/students/delete-payment-method/${paymentMethodId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['paymentMethods'],
        }),
        createPaymentMethodDefault: builder.mutation<void, { paymentMethodId: string }>({
            query: ({ paymentMethodId }) => ({
                url: `/students/default-payment-method`,
                method: 'PUT',
                data: { paymentMethodId },
            }),
            invalidatesTags: ['paymentMethods'],
        }),
        // Add more endpoints as needed
    }),
});

export const { useGetGetTransactionHistoryQuery , useGetStudentSubscriptionQuery, useGetDashboardStatisticsQuery, useCancelSubscriptionMutation, useSetupIntentQuery, useGetSavedPaymentMethodsQuery, useRemovePaymentMethodMutation, useCreatePaymentMethodDefaultMutation} = billingApi;